import { useState } from 'react';

export const CodeApi4 = () => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);

  return (
    <div>
      <code>{"import React, { useState, useEffect } from 'react';"}</code>
      <br />
      <code>{"import axios from 'axios';"}</code>
      <br />
      <br />
      <code>{'const TaskList = () => {'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [tasks, setTasks] = useState([]);'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [loading, setLoading] = useState(true);'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [error, setError] = useState(null);'}
      </code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'useEffect(() => {'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'const fetchTasks = async () => {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'try {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {"const response = await axios.get('https://api.example.com/tasks');"}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'setTasks(response.data);'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'} catch (error) {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'setError(error);'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'} finally {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'setLoading(false);'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'}'}
      </code>
      <br/>
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'};'}</code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'fetchTasks();'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'}, []);'} </code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const handleDelete = async (taskId) => {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'try {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'await axios.delete(`https://api.url/${taskId}`);'}
      </code>
      <br />
      <br/>
      <span style={{ color: '#999', fontSize: `${sValue}px`, paddingLeft: `${pValue + pValue + pValue}px`}}>
          // Remove the deleted task from the list
      </span>
      <br/>
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'setTasks(tasks.filter(task => task.id !== taskId));'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'} catch (error) {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {"console.error('Failed to delete task', error);"}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'}'}
      </code>
      <br/>
      <code style={{ paddingLeft: `${pValue}px` }}>{'};'}</code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'if (loading) return <p>Loading tasks...</p>;'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'if (error) return <p>Error loading tasks: {error.message}</p>;'}
      </code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'return ('}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'<ul>'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'{tasks.map(task => ('}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'<li key={task.id}>'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue + pValue}px` }}>
        {'{task.title}'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue + pValue}px` }}>
        {' <button onClick={() => handleDelete(task.id)}>Delete</button>'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'</li>'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'))}'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'</ul>'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{');'}</code>
      <br />
      <code>{'};'}</code>
      <br />
      <br />
      <code>{'export default TaskList;'}</code>
    </div>
  );
};
